/**
 * Platform detection — usado pra gate features com comportamento
 * iOS-specific (audio session category, webkitSpeechRecognition stub,
 * autoplay policy, etc).
 */

/**
 * Detecta iOS Safari (inclui PWA instalada e Chrome iOS, que também usa
 * WebKit por baixo). iPad em iOS 13+ se reporta como Mac — daí o
 * teste de `maxTouchPoints`.
 *
 * @returns {boolean} true se rodando em iOS/iPadOS/iPhone.
 */
export function isIOS() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  if (typeof navigator.maxTouchPoints === "number" && navigator.maxTouchPoints > 1 && /Mac/.test(ua)) return true;
  return false;
}
